import React from 'react';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import './Bruxism.scss';

const Bruxism = () => {
    return (
        <section className='bruxism-section section-common section-bg pt-100 pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <SectionTitle title="Teeth Grinding (Bruxism)" subTitle="Services Offered" />
                    </div>
                </div>

                {/* Main Intro */}
                <div className="row g-4">
                    <div className="col-12">
                        <p>
                            Many people grind or clench their teeth, often without even realizing it. This condition—called bruxism—can happen during the day, but it's especially common at night while you're sleeping. Over time, grinding and clenching can lead to tooth wear, jaw pain, headaches, and even damage to dental work.
                        </p>

                        <h4>Causes of Teeth Grinding</h4>
                        <p>Bruxism can develop for several reasons, including:</p>
                        <ul className="checklist">
                            <li><strong>Stress and anxiety</strong> – one of the most common triggers</li>
                            <li><strong>Sleep disorders</strong> such as sleep apnea</li>
                            <li><strong>Bite alignment issues</strong> or crooked teeth</li>
                            <li><strong>Lifestyle factors</strong> like caffeine or alcohol intake</li>
                            <li><strong>Certain medications</strong></li>
                        </ul>

                        <p>Understanding the underlying cause is an important step in protecting your teeth and jaw.</p>
                    </div>
                </div>

                {/* Subheading: Treatment Options */}
                <div className="row">
                    <div className="col-12 text-center">
                        <h3 className="bruxism-subtitle">Treatment Options</h3>
                    </div>
                </div>

                {/* Treatment Options Side-by-Side */}
                <div className="row g-4 mt-2">
                    <div className="col-lg-6">
                        <h4>Custom Night Guards</h4>
                        <p>
                            A night guard is a custom-fitted appliance that you wear while sleeping. It creates a protective barrier between your teeth, helping to:
                        </p>
                        <ul className="checklist">
                            <li>Reduce grinding and clenching</li>
                            <li>Prevent wear and chipping of teeth</li>
                            <li>Relieve jaw muscle tension</li>
                        </ul>
                        <p>
                            Because they are designed specifically for your bite, custom night guards are more comfortable and effective than over-the-counter options.
                        </p>
                    </div>
                    <div className="col-lg-6">
                        <h4>Neuromodulator Therapy</h4>
                        <p>
                            For patients with more severe grinding, neuromodulators (Botulinum Toxin injections) can be used to relax the overactive jaw muscles. These injections:
                        </p>
                        <ul className="checklist">
                            <li>Reduce the intensity of clenching and grinding</li>
                            <li>Ease jaw pain, tension headaches, and facial discomfort</li>
                            <li>Help protect the teeth from further damage</li>
                        </ul>
                        <p>
                            This treatment is safe, minimally invasive, and can be repeated as needed for lasting relief.
                        </p>
                    </div>
                </div>

                {/* CTA */}
                <div className="row">
                    <div className="col-12 text-center mt-3">
                        <a className="btn-primary" href='https://www.recomed.co.za/dentist/cape-town/mishqah-dollie/7579/7349/' target="_blank" rel="noopener noreferrer">
                            Book a Bruxism Consultation
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Bruxism;


